import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../services/user/user.service';
import * as jspdf from 'jspdf';
import * as html2canvas from 'html2canvas';
import { TrabajosService, TranslationService } from '../../services/services.index';

declare function init_plugins();

@Component({
  selector: 'app-trabajo',
  templateUrl: './trabajo.component.html',
  styles: []
})
export class TrabajoComponent implements OnInit {

  trabajo: any;
  categoria: any;

  constructor(public _userService: UserService,
              public _trabajosService: TrabajosService,
              private _router: Router,
              public _translationService: TranslationService) {
    if (this._userService.user.estadoTrabajo !== 'aprobado') {
      this._router.navigate(['/dashboard']);
    }
    this._trabajosService.getTrabajoConCategoria(this._userService.user).subscribe((trabajo: any) => {
      this.trabajo = trabajo;
      this.categoria = this.trabajo.categoriasTrabajo[this.trabajo.categoriasTrabajo.length - 1 ];
    });
  }

  ngOnInit() {
    init_plugins();
  }

  generarPdf() {
    let data = document.getElementById('contentToConvert');
    html2canvas(data).then(canvas => {
    // Few necessary setting options
    let imgWidth = 295;
    let pageHeight = 295;
    let imgHeight = canvas.height * imgWidth / canvas.width;
    let heightLeft = imgHeight;

    const contentDataURL = canvas.toDataURL('image/png');
    let pdf = new jspdf('l', 'mm', 'a4'); // A4 size page of PDF
    let position = 0;
    pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight);
    pdf.save('certificado-trabajo.pdf'); // Generated PDF
    });
  }

  inicialesNombres(nombres: string) {
    let iniciales: string = '';
    let arrayNombres: any[] = nombres.split(' ');
    for (let nombre of arrayNombres) {
      iniciales = iniciales + nombre.substr(0, 1);
    }
    return iniciales.toUpperCase();
  }

  superindiceLugares(lugaresTrabajo: any) {
    let superindice: string = '';
    for (let lugar of lugaresTrabajo) {
      superindice = superindice + lugar;
    }
    return superindice;
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados/trabajo/trabajo.component.ts